const STORAGE_KEY = 'ts_dismissed_partial_offer_ids';

const readIds = (): Set<number> => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return new Set();
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return new Set();
    return new Set(parsed.map((id) => Number(id)).filter((id) => Number.isFinite(id) && id > 0));
  } catch {
    return new Set();
  }
};

const writeIds = (ids: Set<number>) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(ids)));
  } catch {
    // ignore quota / private mode
  }
};

export const isDismissedOffer = (offerId: number | null | undefined): boolean => {
  if (offerId == null) return false;
  return readIds().has(Number(offerId));
};

export const dismissOffer = (offerId: number | null | undefined) => {
  if (offerId == null) return;
  const id = Number(offerId);
  if (!Number.isFinite(id) || id <= 0) return;
  const ids = readIds();
  ids.add(id);
  writeIds(ids);
};

export const filterDismissedOffers = <T extends { id?: number | null }>(offers: T[]): T[] =>
  offers.filter((offer) => !isDismissedOffer(offer.id));
